<template>
    <v-dialog
        v-model="dialog"
        width="450"
        transition="fab-transition"
    >
        <v-card class="pl-0 pr-0">
            <v-card-title>
                <v-icon class="mr-3">fas fa-bars</v-icon>
                <span class="subtitle-2">
                    {{ name }}
                </span> 
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pb-0">
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-textarea
                                v-model="description"
                                outlined
                                label="Detalles"
                                hide-details
                                rows="6"
                                readonly
                            >
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions class="pt-0">
                <v-container class="pt-0 pb-0">
                    <v-row justify="center">                        
                        <v-col cols="6">
                            <v-btn dark color="green" block @click="handleOk">
                                Aceptar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>                    
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'DescriptionCustom',
    data () {
        return {
            dialog: false,
            name: null,
            description: null,
        }
    },
    methods: {
        show (product) {
            this.name = product.name;
            this.description = product.description;
            this.dialog = !this.dialog;            
        },
        clearData () {
            this.name = null;
            this.description = null;
        },
        handleOk () {
            this.clearData();
            this.dialog = false;
        }
    },
}
</script>

<style scoped>

</style>